<div class="p-3 rounded-3">
    <div class="row mb-2">
        <div class="col-12 mb-3">
            <div class="titletoptables d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center">
                    <div class="leftsideicons">
                        <img src="../../assets/image/whatsapp-icon.png" alt="multiuser" />
                    </div>
                    <h3 class="mb-0">{{ "WhatsApp Campaign" }}</h3>
                </div>

                <div class="d-flex gap-2">
                    <button class="btn btn-primary btn-sm" (click)="openAddCampaign()"
                        *ngIf="isConnected && currentView === 'campaigns'">
                        <i class="bi bi-plus-lg"></i> Add Campaign
                    </button>
                    <button *ngIf="isConnected" class="btn disconnect btn-sm" (click)="logoutSession()">
                        Disconnect
                    </button>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <!-- QR SECTION -->
            <div *ngIf="!isConnected" class="row box align-items-start">
                <div class="col-12 col-md-7 content text-start">
                    <div class="Heading">
                        To send and receive messages, authorize your WhatsApp:
                    </div>
                    <ul class="text-start d-inline-block">
                        <li>Open WhatsApp</li>
                        <li>Go to Linked Devices</li>
                        <li>Tap Link Device</li>
                        <li>Scan QR code</li>
                    </ul>
                </div>
                <div class="col-12 col-md-5 qr-code text-center mt-2 mt-md-0">
                    <img [src]="qrCodeImage" alt="QR Code" />
                    <p class="qrmsg">
                        If not connected QR will refresh in {{ countdownWP }} seconds...
                    </p>
                </div>
            </div>

            <div *ngIf="isConnected">
                <!-- CAMPAIGNS VIEW -->
                <div *ngIf="currentView === 'campaigns'">
                    <div class="grid-card">
                        <div class="filters-bar">
                            <h5 class="mb-0">Campaigns ({{ totalCampaigns }})</h5>
                            <div class="filter-search" style="margin-left: auto;">
                                <app-search-input style="width: 250px;" [value]="searchTerm"
                                    (valueChange)="searchTerm = $event; onSearch()" (cleared)="clearSearch()"></app-search-input>
                            </div>
                        </div>
                        <app-data-grid>
                            <kendo-grid [data]="campaignsGridData" [height]="600" [loading]="isLoading"
                                [pageSize]="gridState.take" [skip]="gridState.skip" [pageable]="true"
                                [sortable]="true" [sort]="gridState.sort" [groupable]="true" [group]="gridState.group"
                                (dataStateChange)="onDataStateChangeCampaigns($event)" (cellClick)="onCellClick($event)">
                                <kendo-grid-column field="CampaignName" title="Campaign Name"></kendo-grid-column>
                                <kendo-grid-column field="TotalRecords" title="Total" [width]="80"></kendo-grid-column>
                                <kendo-grid-column field="SentRecords" title="Sent" [width]="80"></kendo-grid-column>
                                <kendo-grid-column field="PendingRecords" title="Pending"
                                    [width]="80"></kendo-grid-column>
                                <kendo-grid-column field="MinTimeGapMinutes" title="Min Gap (Mins)"
                                    [width]="130"></kendo-grid-column>
                                <kendo-grid-column field="RandomExtraMinutes" title="Random (Mins)"
                                    [width]="130"></kendo-grid-column>
                                <kendo-grid-column field="StartDate" title="Start Date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ dataItem.StartDate | date: 'dd/MM/yyyy' }}
                                    </ng-template>
                                    <ng-template kendoGridGroupHeaderTemplate let-value="value">
                                        Start Date: {{ value | date: 'dd/MM/yyyy' }}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="EndDate" title="End Date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ dataItem.EndDate | date: 'dd/MM/yyyy' }}
                                    </ng-template>
                                    <ng-template kendoGridGroupHeaderTemplate let-value="value">
                                        End Date: {{ value | date: 'dd/MM/yyyy' }}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="DailyLimit" title="Daily Limit"
                                    [width]="100"></kendo-grid-column>
                                <kendo-grid-column field="Status" title="Status" [width]="120">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <span class="badge py-2" style="min-width: 95px; display: inline-block;" [ngClass]="{
                                            'bg-success': dataItem.Status === 'Active',
                                            'bg-warning': dataItem.Status === 'Draft',
                                            'bg-secondary': dataItem.Status === 'Completed'
                                        }">{{ dataItem.Status || 'Active' }}</span>
                                    </ng-template>
                                    <ng-template kendoGridGroupHeaderTemplate let-value="value">
                                        Status: {{ value || 'Active' }}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column title="Actions" [width]="120" [groupable]="false">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <button class="btn btn-primary btn-sm d-flex align-items-center gap-1"
                                            (click)="viewCampaignMessages(dataItem)" title="View Messages">
                                            <kendo-svg-icon [icon]="icons.view"></kendo-svg-icon> View
                                        </button>
                                    </ng-template>
                                </kendo-grid-column>
                            </kendo-grid>
                        </app-data-grid>
                    </div>
                </div>

                <!-- MESSAGES VIEW (DRILL DOWN) -->
                <div *ngIf="currentView === 'messages'">
                    <div class="row mb-3">
                        <div class="col-12">
                            <button type="button" class="back-link" (click)="backToCampaigns()">
                                <kendo-svg-icon [icon]="icons.back"></kendo-svg-icon> Back to Campaigns
                            </button>
                        </div>
                    </div>
                    <div class="grid-card">
                        <div class="filters-bar">
                            <h5 class="mb-0">Messages for: {{ selectedCampaign?.CampaignName }}</h5>
                        </div>
                        <app-data-grid>
                            <kendo-grid [data]="previewGridData" [height]="550" [loading]="isLoading"
                                [pageSize]="gridState.take" [skip]="gridState.skip" [pageable]="true"
                                [sortable]="true" [sort]="gridState.sort" [groupable]="true" [group]="gridState.group"
                                (dataStateChange)="onDataStateChangeMessages($event)">
                                <kendo-grid-column field="Name" title="Name"></kendo-grid-column>
                                <kendo-grid-column field="Number" title="Number"></kendo-grid-column>
                                <kendo-grid-column field="MessageStatus" title="Status" [width]="120">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <span class="badge" [ngClass]="{
                                            'bg-warning': dataItem.MessageStatus === 'Pending',
                                            'bg-success': dataItem.MessageStatus === 'Sent',
                                            'bg-danger': dataItem.MessageStatus === 'Failed'
                                        }">{{ dataItem.MessageStatus }}</span>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="SentOn" title="Sent On">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{ dataItem.SentOn | date: 'dd/MM/yyyy HH:mm' }}
                                    </ng-template>
                                    <ng-template kendoGridGroupHeaderTemplate let-value="value">
                                        Sent On: {{ value | date: 'dd/MM/yyyy HH:mm' }}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="ErrorMessage" title="Error"></kendo-grid-column>
                            </kendo-grid>
                        </app-data-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ADD CAMPAIGN MODAL (Custom Overlay) -->
<div class="custom-modal-overlay" *ngIf="campaignFormVisible">
    <div class="custom-modal-content">
        <div class="modal-header d-flex justify-content-between align-items-center mb-4 pt-3 px-3">
            <h4 class="mb-0">Add New Campaign</h4>
            <button type="button" class="btn-close" (click)="campaignFormVisible = false"></button>
        </div>
        <div class="modal-body px-3 pb-3">
            <form [formGroup]="MessageForm">
                <div class="row g-3">
                    <div class="col-md-6">
                        <label class="app-field-label">Campaign Name<span class="app-field-required">*</span></label>
                        <mat-form-field class="w-100 custom-blue">
                            <input matInput placeholder="Enter Campaign Name" formControlName="CampaignName" />
                            <mat-error
                                *ngIf="MessageForm.get('CampaignName')?.touched && MessageForm.get('CampaignName')?.invalid">
                                Campaign Name is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <label class="dp-label">Start Date</label>
                        <app-date-picker formControlName="StartDate"></app-date-picker>
                    </div>
                    <div class="col-md-3">
                        <label class="dp-label">End Date</label>
                        <app-date-picker formControlName="EndDate"></app-date-picker>
                    </div>

                    <div class="col-md-4">
                        <label class="app-field-label">Daily Limit</label>
                        <mat-form-field class="w-100 custom-blue">
                            <input matInput type="number" formControlName="DailyLimit" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <label class="app-field-label">Min Gap (Mins)</label>
                        <mat-form-field class="w-100 custom-blue">
                            <input matInput type="number" formControlName="MinTimeGapMinutes" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <label class="app-field-label">Random Extra (Mins)</label>
                        <mat-form-field class="w-100 custom-blue">
                            <input matInput type="number" formControlName="RandomExtraMinutes" />
                        </mat-form-field>
                    </div>

                    <div class="col-12">
                        <mat-label class="form-label fw-bold">Message Template</mat-label>
                        <kendo-editor formControlName="Message" style="height: 200px;"></kendo-editor>
                    </div>

                    <div class="col-12">
                        <mat-label class="form-label fw-bold">Upload Recipients (Excel)</mat-label>
                        <div class="input-group input-group-sm">
                            <input type="file" (change)="onFileChange($event)" class="form-control" />
                            <button class="btn btn-outline-secondary" type="button" (click)="uploadFile()">
                                <kendo-svg-icon [icon]="icons.view"></kendo-svg-icon> Preview
                            </button>
                        </div>
                        <small class="text-muted">Columns: Name, Number</small>
                    </div>

                    <!-- PREVIEW IN MODAL -->
                    <div class="col-12 mt-3" *ngIf="previewData?.length">
                        <mat-label class="form-label fw-bold">Preview ({{ previewData.length }} records)</mat-label>
                        <kendo-grid [data]="previewData.slice(0, 5)" [height]="180">
                            <kendo-grid-column field="Name" title="Name"></kendo-grid-column>
                            <kendo-grid-column field="Number" title="Number"></kendo-grid-column>
                        </kendo-grid>
                        <small *ngIf="previewData.length > 5">Showing first 5 of {{ previewData.length }}</small>
                    </div>
                </div>
            </form>
        </div>
        <div class="modal-footer d-flex justify-content-end gap-2 p-3 border-top">
            <button class="btn btn-secondary btn-sm" (click)="campaignFormVisible = false">Cancel</button>
            <button class="btn btn-primary btn-sm" (click)="saveCampaign()">Save Campaign</button>
        </div>
    </div>
</div>